import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";

import type { IInitI18nInstanceProps } from "./interfaces.ts";

const getLanguageFromLocale = (currentLang: string) => {
  return currentLang ? currentLang.split("-")[0] : "en";
};

export default async function initI18nInstance({
  locale,
  namespaces,
  i18nInstance,
  resources,
  useBackend,
}: IInitI18nInstanceProps) {
  const instance = i18nInstance || createInstance();

  const lang = getLanguageFromLocale(locale);

  instance.use(initReactI18next);

  useBackend?.(instance);

  await instance.init({
    lng: lang,
    resources,
    fallbackLng: "en",
    partialBundledLanguages: Boolean(resources),
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
    defaultNS: namespaces[0],
    fallbackNS: namespaces[0],
    ns: namespaces,
    preload: resources ? [] : Array.from(new Set([lang, "en"])),
    detection: {
      order: ["path"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },
    supportedLngs: [
      "en",
      "de",
      "cs",
      "da",
      "it",
      "es",
      "ru",
      "fr",
      "fi",
      "hu",
      "nl",
      "pl",
      "pt",
      "sk",
      "sv",
    ],
  });

  return {
    i18n: instance,
    lang,
    resources: instance.services.resourceStore.data,
    t: instance.t,
  };
}
